import uom from '@/api/inventory/uom'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  formModels:[]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_VIEW_MODELS(state, {data, index}){
    if(!index){
      state.formModels = data
    }else{
      state.formModels[index] = data[index]
    }
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attributes
    )
    return uom.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return uom.store(data)
  },
  update(context, { id, data }) {
    return uom.update(id, data)
  },
  destroy(context, id) {
    return uom.destroy(id)
  },
  async getFormViewData(context, { params, index }) {
    let response = await uom.formModel({ params: params })
    if(response){
      context.commit('SET_VIEW_MODELS', { data: response.data, index: index })
    }
    return response;
  }
}